// import React, { useState, useEffect } from 'react';
// import { Box, MenuItem, FormControl, Select, InputLabel } from "@mui/material";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { tokens } from "../../theme";
// import Header from "../../components/Header";
// import { useTheme } from "@mui/material";

// const columns = [
//   { field: 'name', headerName: 'Name', flex: 1 },
//   { field: 'date', headerName: 'Date', flex: 1 },
//   { field: 'day', headerName: 'Day', flex: 1 },
// ];

// const PublicHolidays = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const userEmail = localStorage.getItem('UserEmail') || '';
  
//   const [dataholidys, setDataHolidays] = useState([]);
//   const [filteredHolidays, setFilteredHolidays] = useState([]);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year
//   const [loading, setLoading] = useState(true);

//   // Generate years from 2000 to the current year
//   const currentYear = new Date().getFullYear();
//   const yearOptions = Array.from({ length: currentYear - 2000 + 1 }, (_, index) => 2000 + index);

//   const fetchHolidays = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/get-public-holidays`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch holidays");
//       }
//       const data = await response.json();
      
//       setDataHolidays(data.holidays); // Set all holidays initially
//       filterHolidays(data.holidays); // Filter holidays based on the selected year
//     } catch (error) {
//       console.error("Error fetching holidays:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filterHolidays = (holidays) => {
//     const holidaysForYear = holidays.filter((holiday) => {
//       const holidayYear = new Date(holiday.date).getFullYear();
//       return holidayYear === selectedYear;
//     });
//     setFilteredHolidays(holidaysForYear); // Update the filtered holidays
//   };

//   useEffect(() => {
//     fetchHolidays(); // Fetch holidays when component mounts
//   }, [userEmail]);

//   useEffect(() => {
//     filterHolidays(dataholidys); // Re-filter holidays when selectedYear changes
//   }, [selectedYear, dataholidys]);

//   const handleYearChange = (event) => {
//     const selectedYear = event.target.value;
//     setSelectedYear(selectedYear); // Update the selected year
//   };

//   return (
//     <Box m="20px">
//       <Header
//         title="HOLIDAYS OF DEVANGLES SOFTWARE PVT LTD"
//         subtitle="List of Holidays"
//       />
      
//       {/* Year Selector */}
//       <Box m="20px 0">
//         <FormControl fullWidth>
//           <InputLabel>Year</InputLabel>
//           <Select
//             value={selectedYear}
//             onChange={handleYearChange}
//             label="Year"
//             MenuProps={{
//               PaperProps: {
//                 style: {
//                   maxHeight: 200, // Limit the height of the dropdown
//                   overflowY: 'auto', // Enable scrolling
//                 },
//               },
//             }}
//           >
//             {/* Dynamically create the list of years from 2000 to current year */}
//             {yearOptions.map((year) => (
//               <MenuItem key={year} value={year}>
//                 {year}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Box>

//       <Box
//         m="40px 0 0 0"
//         height="75vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-cell": {
//             borderBottom: "none",
//           },
//           "& .name-column--cell": {
//             color: colors.greenAccent[300],
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.blueAccent[700],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: colors.primary[400],
//           },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[700],
//           },
//           "& .MuiCheckbox-root": {
//             color: `${colors.greenAccent[200]} !important`,
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//           },
//         }}
//       >
//         <DataGrid
//           rows={filteredHolidays} // Show filtered holidays based on the selected year
//           columns={columns}
//           pageSize={10}
//           components={{ Toolbar: GridToolbar }}
//           loading={loading}
//         />
//       </Box>
//     </Box>
//   );
// };

// export default PublicHolidays;
// import React, { useState, useEffect, useCallback } from 'react';
// import { 
//   Box, MenuItem, FormControl, Select, InputLabel, Button, 
//   Modal, IconButton, Typography, TextField 
// } from "@mui/material";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { tokens } from "../../theme";
// import Header from "../../components/Header";
// import { useTheme } from "@mui/material";
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';

// const PublicHolidays = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const userLevel = localStorage.getItem("level");

//   const [dataHolidays, setDataHolidays] = useState([]);
//   const [filteredHolidays, setFilteredHolidays] = useState([]);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [selectedLocation, setSelectedLocation] = useState("Pune");
//   const [loading, setLoading] = useState(true);
//   const [openModal, setOpenModal] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [formData, setFormData] = useState({
//     id: "",
//     name: "",
//     date: "",
//     day: "",
//     location: "Pune"
//   });
//   const [message, setMessage] = useState("");

//   const currentYear = new Date().getFullYear();
//   const yearOptions = Array.from({ length: currentYear - 2000 + 1 }, (_, index) => 2000 + index);

//   const fetchHolidays = useCallback(async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/get-public-holidays`);
//       if (!response.ok) throw new Error("Failed to fetch holidays");
//       const data = await response.json();
//       setDataHolidays(data.holidays);
//       filterHolidays(data.holidays);
//     } catch (error) {
//       console.error("Error fetching holidays:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   const filterHolidays = useCallback((holidays) => {
//     const holidaysForYearAndLocation = holidays.filter((holiday) => {
//       const holidayYear = new Date(holiday.date).getFullYear();
//       return holidayYear === selectedYear && holiday.location.toLowerCase() === selectedLocation.toLowerCase();
//     });
//     setFilteredHolidays(holidaysForYearAndLocation);
//   }, [selectedYear, selectedLocation]);

//   useEffect(() => {
//     fetchHolidays();
//   }, [fetchHolidays]);

//   useEffect(() => {
//     filterHolidays(dataHolidays);
//   }, [filterHolidays, selectedYear, selectedLocation, dataHolidays]);

//   const handleYearChange = (event) => {
//     setSelectedYear(event.target.value);
//   };

//   const handleLocationChange = (event) => {
//     setSelectedLocation(event.target.value);
//   };

//   const getDayFromDate = (dateString) => {
//     const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//     const date = new Date(dateString);
//     return daysOfWeek[date.getDay()];
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "date") {
//       setFormData({ ...formData, date: value, day: getDayFromDate(value) });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const endpoint = isEditMode 
//         ? `${process.env.REACT_APP_BACKEND_URL_LMS}/update-public-holiday`
//         : `${process.env.REACT_APP_BACKEND_URL_LMS}/add-public-holiday`;
      
//       const response = await fetch(endpoint, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(isEditMode ? formData : {
//           name: formData.name,
//           date: formData.date,
//           day: formData.day,
//           location: formData.location
//         }),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setMessage(data.message);
//         fetchHolidays();
//         setTimeout(() => {
//           setOpenModal(false);
//           setMessage("");
//           setIsEditMode(false);
//         }, 1500);
//       } else {
//         setMessage(data.error);
//       }
//     } catch (error) {
//       setMessage("Error: " + error.message);
//     }
//   };

//   const handleOpenModal = () => {
//     setOpenModal(true);
//     setIsEditMode(false);
//     setFormData({ id: "", name: "", date: "", day: "", location: "Pune" });
//     setMessage("");
//   };

//   const handleEditClick = (holiday) => {
//     setOpenModal(true);
//     setIsEditMode(true);
//     setFormData({
//       id: holiday.id,
//       name: holiday.name,
//       date: holiday.date,
//       day: holiday.day,
//       location: holiday.location || "Pune"
//     });
//     setMessage("");
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this holiday?")) {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/delete-public-holiday`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ id }),
//         });
        
//         if (response.ok) {
//           fetchHolidays();
//         } else {
//           const data = await response.json();
//           alert(data.error || "Failed to delete holiday");
//         }
//       } catch (error) {
//         alert("Error: " + error.message);
//       }
//     }
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setIsEditMode(false);
//     setMessage("");
//   };

//   const baseColumns = [
//     { field: 'name', headerName: 'Name', flex: 1 },
//     { field: 'date', headerName: 'Date', flex: 1 },
//     { field: 'day', headerName: 'Day', flex: 1 },
//     { field: 'location', headerName: 'Location', flex: 1 },
//   ];

//   const adminColumns = [
//     ...baseColumns,
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       flex: 1,
//       renderCell: (params) => (
//         <Box>
//           <IconButton
//             onClick={() => handleEditClick(params.row)}
//             color={theme.palette.mode === "dark" ? "default" : "primary"}
//             sx={{
//               color: theme.palette.mode === "dark" ? "white" : "black",
//             }}
//           >
//             <EditIcon />
//           </IconButton>
//           <IconButton onClick={() => handleDelete(params.row.id)} color="error">
//             <DeleteIcon />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   const columns = userLevel === "admin" ? adminColumns : baseColumns;

//   return (
//     <Box m="20px">
//       <Header
//         title="HOLIDAYS OF DEVANGLES SOFTWARE PVT LTD"
//         subtitle="List of Holidays"
//       />
      
//       <Box display="flex" alignItems="center" gap="10px">
//         <Box width="200px" m="20px 0">
//           <FormControl fullWidth>
//             <InputLabel>Year</InputLabel>
//             <Select
//               value={selectedYear}
//               onChange={handleYearChange}
//               label="Year"
//               MenuProps={{
//                 PaperProps: {
//                   style: {
//                     maxHeight: 200,
//                     overflowY: 'auto',
//                   },
//                 },
//               }}
//             >
//               {yearOptions.map((year) => (
//                 <MenuItem key={year} value={year}>
//                   {year}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>

//         <Box width="200px" m="20px 0">
//           <FormControl fullWidth>
//             <InputLabel>Location</InputLabel>
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               label="Location"
//               MenuProps={{
//                 PaperProps: {
//                   style: {
//                     maxHeight: 200,
//                     overflowY: 'auto',
//                   },
//                 },
//               }}
//             >
//               <MenuItem value="Pune">Pune</MenuItem>
//               <MenuItem value="Ahmedabad">Ahmedabad</MenuItem>
//             </Select>
//           </FormControl>
//         </Box>

//         {userLevel === "admin" && (
//           <Button
//             variant="contained"
//             color="secondary"
//             onClick={handleOpenModal}
//             sx={{
//               backgroundColor: colors.blueAccent[700],
//               color: colors.grey[100],
//               fontSize: "14px",
//               fontWeight: "bold",
//               padding: "10px 20px",
//               "&:hover": {
//                 backgroundColor: colors.blueAccent[800],
//               }
//             }}
//           >
//             Add Public Holiday
//           </Button>
//         )}
//       </Box>

//       <Box
//         m="40px 0 0 0"
//         height="75vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-cell": {
//             borderBottom: "none",
//           },
//           "& .name-column--cell": {
//             color: colors.greenAccent[300],
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.blueAccent[700],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: colors.primary[400],
//           },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[700],
//           },
//           "& .MuiCheckbox-root": {
//             color: `${colors.greenAccent[200]} !important`,
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//           },
//         }}
//       >
//         <DataGrid
//           rows={filteredHolidays}
//           columns={columns}
//           pageSize={10}
//           components={{ Toolbar: GridToolbar }}
//           loading={loading}
//         />
//       </Box>

//       <Modal open={openModal} onClose={handleCloseModal}>
//         <Box
//           sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: 400,
//             bgcolor: colors.primary[400],
//             boxShadow: 24,
//             p: 4,
//             borderRadius: 2,
//           }}
//         >
//           <Typography variant="h3" sx={{ color: colors.greenAccent[500], mb: 3 }}>
//             {isEditMode ? "Edit Public Holiday" : "Add Public Holiday"}
//           </Typography>
          
//           <form onSubmit={handleSubmit}>
//             {isEditMode && (
//               <FormControl fullWidth sx={{ mb: 2 }}>
//                 <InputLabel shrink htmlFor="id-input" sx={{ color: colors.grey[100] }}>
//                   Holiday ID
//                 </InputLabel>
//                 <Box mt={2}>
//                   <TextField
//                     type="text"
//                     name="id"
//                     id="id-input"
//                     value={formData.id}
//                     readOnly
//                     fullWidth
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "& fieldset": { borderColor: colors.grey[700] },
//                         "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                       },
//                       "& .MuiInputBase-input": {
//                         color: colors.grey[100],
//                         backgroundColor: colors.grey[500],
//                         borderRadius: "5px",
//                         cursor: "not-allowed",
//                       },
//                     }}
//                   />
//                 </Box>
//               </FormControl>
//             )}

//             <FormControl fullWidth sx={{ mb: 2 }}>
//               <InputLabel shrink htmlFor="name-input" sx={{ color: colors.grey[100] }}>
//                 Holiday Name
//               </InputLabel>
//               <Box mt={2}>
//                 <TextField
//                   type="text"
//                   name="name"
//                   id="name-input"
//                   value={formData.name}
//                   onChange={handleChange}
//                   placeholder="Enter Holiday Name"
//                   required
//                   fullWidth
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                     "& .MuiInputBase-input": {
//                       color: colors.grey[100],
//                       backgroundColor: colors.primary[400],
//                       borderRadius: "5px",
//                     },
//                     "& .MuiInputBase-input::placeholder": {
//                       color: colors.grey[500],
//                       opacity: 1,
//                     },
//                   }}
//                 />
//               </Box>
//             </FormControl>

//             <FormControl fullWidth sx={{ mb: 2 }}>
//               <InputLabel shrink htmlFor="date-input" sx={{ color: colors.grey[100] }}>
//                 Date
//               </InputLabel>
//               <Box mt={2}>
//                 <TextField
//                   type="date"
//                   name="date"
//                   id="date-input"
//                   value={formData.date}
//                   onChange={handleChange}
//                   required
//                   fullWidth
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                     "& .MuiInputBase-input": {
//                       color: colors.grey[100],
//                       backgroundColor: colors.primary[400],
//                       borderRadius: "5px",
//                     },
//                   }}
//                 />
//               </Box>
//             </FormControl>
            
//             <FormControl fullWidth sx={{ mb: 3 }}>
//               <InputLabel shrink htmlFor="day-input" sx={{ color: colors.grey[100] }}>
//                 Day
//               </InputLabel>
//               <Box mt={2}>
//                 <TextField
//                   type="text"
//                   name="day"
//                   id="day-input"
//                   value={formData.day}
//                   readOnly
//                   placeholder="Select a date to auto-fill"
//                   fullWidth
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                     "& .MuiInputBase-input": {
//                       color: colors.grey[100],
//                       backgroundColor: colors.grey[600],
//                       borderRadius: "5px",
//                       cursor: "not-allowed",
//                     },
//                     "& .MuiInputBase-input::placeholder": {
//                       color: colors.grey[500],
//                       opacity: 1,
//                     },
//                   }}
//                 />
//               </Box>
//             </FormControl>

//             <FormControl fullWidth sx={{ mb: 3 }}>
//               <InputLabel shrink htmlFor="location-input" sx={{ color: colors.grey[100] }}>
//                 Location
//               </InputLabel>
//               <Box mt={2}>
//                 <Select
//                   name="location"
//                   id="location-input"
//                   value={formData.location}
//                   onChange={handleChange}
//                   required
//                   fullWidth
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                     "& .MuiSelect-select": {
//                       color: colors.grey[100],
//                       backgroundColor: colors.primary[400],
//                       borderRadius: "5px",
//                     },
//                   }}
//                 >
//                   <MenuItem value="Pune">Pune</MenuItem>
//                   <MenuItem value="Ahmedabad">Ahmedabad</MenuItem>
//                 </Select>
//               </Box>
//             </FormControl>

//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               sx={{
//                 padding: "12px",
//                 fontSize: "16px",
//                 mb: 2,
//                 backgroundColor: colors.greenAccent[700],
//                 color: colors.grey[100],
//                 '&:hover': {
//                   backgroundColor: colors.greenAccent[800],
//                 }
//               }}
//             >
//               {isEditMode ? "Update Holiday" : "Add Holiday"}
//             </Button>

//             {message && (
//               <Typography sx={{ 
//                 mt: 1,
//                 fontWeight: "bold", 
//                 color: message.includes("successfully") ? colors.greenAccent[500] : colors.redAccent[500]
//               }}> 
//                 {message}
//               </Typography>
//             )}
//           </form>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default PublicHolidays;




import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Button,
  Modal,
  IconButton,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Paper,
  Grid,
  Chip,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const PublicHolidays = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const userLevel = localStorage.getItem("level");

  const [dataHolidays, setDataHolidays] = useState([]);
  const [filteredHolidays, setFilteredHolidays] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedLocation, setSelectedLocation] = useState("Pune");
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    date: "",
    day: "",
    location: "Pune",
    is_common: false,
  });
  const [message, setMessage] = useState("");

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: currentYear - 2000 + 1 },
    (_, index) => 2000 + index
  );
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  const fetchHolidays = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_LMS}/get-public-holidays?location=${selectedLocation}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
      if (!response.ok) throw new Error("Failed to fetch holidays");
      const data = await response.json();
      setDataHolidays(data.holidays);
      filterHolidays(data.holidays);
    } catch (error) {
      console.error("Error fetching holidays:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedLocation]);

  const filterHolidays = useCallback(
    (holidays) => {
      const holidaysForYear = holidays.filter((holiday) => {
        const holidayYear = new Date(holiday.date).getFullYear();
        if (selectedLocation === "All") {
          return holidayYear === selectedYear && holiday.is_common;
        }
        return (
          holidayYear === selectedYear &&
          (holiday.location === selectedLocation || holiday.is_common)
        );
      });
      setFilteredHolidays(holidaysForYear);
    },
    [selectedYear, selectedLocation]
  );

  useEffect(() => {
    fetchHolidays();
  }, [fetchHolidays]);

  useEffect(() => {
    filterHolidays(dataHolidays);
  }, [filterHolidays, dataHolidays]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "is_common") {
      setFormData((prevState) => ({
        ...prevState,
        is_common: checked,
        location: checked ? "All" : "Pune",
      }));
    } else if (name === "date") {
      const day = new Date(value).toLocaleDateString("en-US", {
        weekday: "long",
      });
      setFormData((prevState) => ({ ...prevState, date: value, day }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const endpoint = isEditMode
        ? `${process.env.REACT_APP_BACKEND_URL_LMS}/update-public-holiday`
        : `${process.env.REACT_APP_BACKEND_URL_LMS}/add-public-holiday`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        fetchHolidays();
        setTimeout(() => {
          setOpenModal(false);
          setMessage("");
        }, 1500);
      } else {
        setMessage(data.error);
      }
    } catch (error) {
      setMessage("Error: " + error.message);
    }
  };

  const handleOpenModal = () => {
    setFormData({
      id: "",
      name: "",
      date: "",
      day: "",
      location: "Pune",
      is_common: false,
    });
    setOpenModal(true);
    setIsEditMode(false);
    setMessage("");
  };

  const handleEditClick = (holiday) => {
    setFormData({
      id: holiday.id,
      name: holiday.name,
      date: holiday.date,
      day: holiday.day,
      location: holiday.location,
      is_common: holiday.is_common,
    });
    setOpenModal(true);
    setIsEditMode(true);
    setMessage("");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this holiday?")) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_LMS}/delete-public-holiday`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
            body: JSON.stringify({ id }),
          }
        );

        if (response.ok) {
          fetchHolidays();
        } else {
          const data = await response.json();
          alert(data.error || "Failed to delete holiday");
        }
      } catch (error) {
        alert("Error: " + error.message);
      }
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setMessage("");
    setIsEditMode(false);
  };

  const columns = [
    { 
      field: "name", 
      headerName: "Holiday Name", 
      flex: 1,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          <EventIcon sx={{ color: colors.greenAccent[500], mr: 1 }} />
          <Typography variant="body1">{params.row.name}</Typography>
        </Box>
      )
    },
    { 
      field: "date", 
      headerName: "Date", 
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body1">
          {new Date(params.row.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </Typography>
      )
    },
    { 
      field: "day", 
      headerName: "Day", 
      flex: 1,
      renderCell: (params) => (
        <Chip 
          label={params.row.day} 
          sx={{ 
            backgroundColor: colors.blueAccent[700],
            color: colors.grey[100],
            fontWeight: 'bold'
          }} 
        />
      )
    },
    {
      field: "is_common",
      headerName: "Type",
      flex: 1,
      renderCell: (params) => (
        params.row.is_common ? (
          <Chip 
            label="Common" 
            color="success" 
            variant="outlined"
          />
        ) : (
          <Box display="flex" alignItems="center">
            <LocationOnIcon sx={{ color: colors.blueAccent[500], mr: 1 }} />
            <Typography variant="body2">{params.row.location}</Typography>
          </Box>
        )
      ),
    },
    userLevel === "admin" && {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <Box>
          <IconButton
            onClick={() => handleEditClick(params.row)}
         
            sx={{
              '&:hover': {
                backgroundColor: colors.grey[500],
                
              },
              color:colors.greenAccent[500]
            }}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(params.row.id)}
            color="error"
            sx={{
              '&:hover': {
                backgroundColor: colors.redAccent[800],
              }
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ),
    },
  ].filter(Boolean);
 
    const customInputSx = {
      borderRadius: "8px",
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#aaa !important",
        },
    };

    const customLabelSx = (colors) => ({
      fontSize: "16.5px",
      fontWeight: "bold",
      color: colors.grey[100],
      letterSpacing: "-0.5px",
      "&.Mui-focused": {
        color: colors.grey[100],
      },
      "&.MuiInputLabel-shrink": {
        color: colors.grey[100],
      },
    });
  return (
    <Box m="20px">
      <Header
        title="PUBLIC HOLIDAYS"
        subtitle={`List of holidays for ${selectedLocation} in ${selectedYear}`}
      />
      
      <Paper elevation={3} sx={{ p: 3, mb: 3, backgroundColor: colors.primary[400] }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel sx={customLabelSx(colors)} id="year-label">
                Year
              </InputLabel>
              <Select 
                labelId="year-label"
                id="year-select"
                value={selectedYear}
                onChange={handleYearChange}
                label="Year" 
                sx={{ ...customInputSx, color: colors.grey[100] }}
              >
                {yearOptions.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel sx={customLabelSx(colors)} id="location-label">
                Location
              </InputLabel>
              <Select 
                labelId="location-label"
                id="location-select"
                value={selectedLocation}
                onChange={handleLocationChange}
                label="Location"  // Important!
                sx={{ ...customInputSx, color: colors.grey[100] }}
              >
                <MenuItem value="All">All Locations</MenuItem>
                <MenuItem value="Pune">Pune</MenuItem>
                <MenuItem value="Ahmedabad">Ahmedabad</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {userLevel === "admin" && (
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                onClick={handleOpenModal}
                fullWidth
                sx={{
                  height: '56px',
                  backgroundColor: colors.greenAccent[600],
                  color: colors.grey[100],
                  '&:hover': {
                    backgroundColor: colors.greenAccent[700],
                  },
                }}
              >
                Add Holiday
              </Button>
            </Grid>
          )}
        </Grid>
      </Paper>

      <Paper elevation={3} sx={{ 
        height: "75vh",
        backgroundColor: colors.primary[400],
        '& .MuiDataGrid-root': {
          border: 'none',
          color: colors.grey[100],
        },
        '& .MuiDataGrid-cell': {
          borderBottom: `1px solid ${colors.primary[500]} !important`,
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: colors.blueAccent[700],
          borderBottom: 'none',
          fontSize: '16px',
        },
        '& .MuiDataGrid-virtualScroller': {
          backgroundColor: colors.primary[400],
        },
        '& .MuiDataGrid-footerContainer': {
          borderTop: 'none',
          backgroundColor: colors.blueAccent[700],
        },
        '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
          color: `${colors.grey[100]} !important`,
        },
      }}>
        <DataGrid
          rows={filteredHolidays}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          loading={loading}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableSelectionOnClick
        />
      </Paper>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: '90%', sm: 500 },
            bgcolor: colors.primary[400],
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            outline: 'none',
          }}
        >
          <Typography 
            variant="h3" 
            sx={{ 
              color: colors.greenAccent[500], 
              mb: 3,
              textAlign: 'center',
              fontWeight: 'bold',
              borderBottom: `2px solid ${colors.greenAccent[500]}`,
              pb: 1
            }}
          >
            {isEditMode ? "Edit Holiday" : "Create New Holiday"}
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  name="name"
                  label="Holiday Name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter holiday name"
                  required
                  fullWidth
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: colors.grey[100],
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: colors.grey[700] },
                      '&:hover fieldset': { borderColor: colors.greenAccent[500] },
                      '&.Mui-focused fieldset': { borderColor: colors.greenAccent[500] },
                      color: colors.grey[100],
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="date"
                  label="Date"
                  type="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: colors.grey[100],
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: colors.grey[700] },
                      '&:hover fieldset': { borderColor: colors.greenAccent[500] },
                      '&.Mui-focused fieldset': { borderColor: colors.greenAccent[500] },
                      color: colors.grey[100],
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="day"
                  label="Day"
                  value={formData.day}
                  disabled
                  fullWidth
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: colors.grey[100],
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: colors.grey[700] },
                      '&.Mui-focused fieldset': { borderColor: colors.greenAccent[500] },
                      backgroundColor: colors.grey[700],
                      color: colors.grey[100],
                    },
                  }}
                />
              </Grid>

              {userLevel === "admin" && (
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.is_common}
                        onChange={handleChange}
                        name="is_common"
                        sx={{
                          color: colors.greenAccent[500],
                          '&.Mui-checked': {
                            color: colors.greenAccent[500],
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body1" sx={{ color: colors.grey[100] }}>
                        Common Holiday (Applies to all locations)
                      </Typography>
                    }
                  />
                </Grid>
              )}

              {!formData.is_common && (
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel sx={{ color: colors.grey[100] }}>Location</InputLabel>
                    <Select
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      required
                      sx={{
                        '& .MuiInputLabel-root': {
                          color: colors.grey[100],
                        },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': { borderColor: colors.grey[700] },
                          '&:hover fieldset': { borderColor: colors.greenAccent[500] },
                          '&.Mui-focused fieldset': { borderColor: colors.greenAccent[500] },
                          color: colors.grey[100],
                        },
                        '& .MuiSvgIcon-root': {
                          color: colors.grey[100],
                        },
                      }}
                    >
                      <MenuItem value="Pune">Pune</MenuItem>
                      <MenuItem value="Ahmedabad">Ahmedabad</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  size="large"
                  sx={{
                    mt: 2,
                    py: 1.5,
                    fontSize: '16px',
                    fontWeight: 'bold',
                    backgroundColor: colors.greenAccent[600],
                    color: colors.grey[100],
                    '&:hover': {
                      backgroundColor: colors.greenAccent[700],
                    },
                  }}
                >
                  {isEditMode ? "Update Holiday" : "Create Holiday"}
                </Button>
              </Grid>

              {message && (
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      mt: 1,
                      textAlign: 'center',
                      fontWeight: 'bold',
                      color: message.includes("successfully")
                        ? colors.greenAccent[500]
                        : colors.redAccent[500],
                    }}
                  >
                    {message}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </form>
        </Paper>
      </Modal>
    </Box>
  );
};

export default PublicHolidays;